export default "/images/vendor/flag-icon-css/flags/1x1/mv.svg?91b2c27c9c550f55860739fda63e1ec9";